export default __webpack_public_path__ + "static/media/profile_icon.99d089e2.svg";